export const invalidSearch = `<div class="modal-payment">
                                <p class="lead">
                                Não conseguimos encontrar seus voos. <br />
                                Vamos te levar para a Home para refazer a sua busca
                                </p>
                                <div class="col-xs-16">
                                <button type="button" onclick="javascript:window.location.href='/'" class="btn btn-success">
                                    OK
                                </button>
                            </div>
                            </div>`;